export const globalState = {
    averageProcessingTime: 16,
}